import React, { Suspense, lazy } from "react";

import { SimpleGrid } from "@chakra-ui/react";
const GalleryCarousal = lazy(() => import("./GalleryCarousal.jsx"));
const VideoCarousal = lazy(() => import("./VideoCarousal.jsx"));

const GallaryAndVideo = () => {
  return (
    <div id="gallery-home">
      <div className="container">
        <SimpleGrid
          columns={[1, 2, 2, 2]} // for 2 columns)
          // columns={1} // Explicitly set to one column (on model code of conduct)
          justifyContent="center" // Center the items within the grid columns
        >
          {/* <GalleryThree /> */}
          {/* <GallerySection /> */}
          {/* to be hidden for model code of conduct */}
          <Suspense fallback={<div>Loading gallery...</div>}>
            <GalleryCarousal />
          </Suspense>
          <Suspense fallback={<div>Loading videos...</div>}>
            <VideoCarousal />
          </Suspense>
        </SimpleGrid>
      </div>
    </div>
  );
};

export default GallaryAndVideo;
